document.addEventListener('DOMContentLoaded', function() {
    // アプリブロックの特定のセレクタを指定
    const appBlock = document.querySelector('.sns-gift-product-container');
    if (appBlock) {
    // 商品ページのメインコンテナに特別なクラスを追加
    const productContainer = document.querySelector('.product');
    if (productContainer) {
        productContainer.classList.add('has-app-block');
    }
    }
});

function updateSPPadding() {
    var info = document.querySelector('product-info');
    var breadcrumb = info?.querySelector('.product-detail-breadcrumb');
    if (!info || !breadcrumb) return;
    if (window.matchMedia("screen and (max-width: 749px)").matches) {
    // 高さ取得
    var breadcrumbHeight = breadcrumb.offsetHeight;
    // 上部余白としてセット
    info.style.paddingTop = breadcrumbHeight + 'px';
    } else {
    info.style.paddingTop = ""; // PC時はpadding解除
    }
}
document.addEventListener("DOMContentLoaded", updateSPPadding);
window.addEventListener("resize", updateSPPadding);
